export enum ReferralSourceEnum {
  INTERNAL_REFERRAL = 'Internal Referral',
  CLIENT_SELF_REFERRAL = 'Client Self Referral',
  DIRECT_REFERRAL = 'Direct Referral'
}
